<script setup>
import {ref, watch} from 'vue'
import moment from 'moment'
import api from '@/services/api'

const props = defineProps({
    options: Object,
})

const emit = defineEmits(['hide-modal'])

const items = ref(null)

watch(
    () => props.options?.bookingId,
    async (bookingId) => {
        if (!bookingId) {
            items.value = null
            return
        }
        try {
            const response = await api.get('api/component/odp_bookings_payment_log', {
                params: {
                    bookingId: bookingId,
                    sort: 'date',
                }
            })
            items.value = response?.data?.items || []
        } catch (error) {
            console.error('Failed to fetch booking payment log items:', error)
            items.value = []
        }
    },
    {immediate: true}
)

const getDate = (timestamp) => {
    if (!timestamp) return ''
    const dateValue = timestamp * 1000
    return moment(dateValue).format('DD/MM/YYYY @ HH:mm')
}
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Payment log</h4>
                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>

            <div class="modal-body">
                <div v-if="items" class="list-group">
                    <div v-for="item in items" :key="item.id" class="list-group-item">
                        <div>
                            £{{ item.amount }} - {{ item.label }}
                            <span v-if="item.paymentNote"> - {{ item.paymentNote }}</span>
                        </div>

                        <span class="date font-monospace">
                            {{ getDate(item.date) }}
                        </span>
                    </div>
                </div>
                <div v-else class="text-center p-3">
                    Loading logs...
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.list-group-item {
    display: flex;
    align-items: center;
}

.list-group-item > :first-child {
    flex: auto;
}

.date {
    background: #eaeaea;
    display: inline-block;
    padding: 3px 5px;
    border-radius: 3px;
    font-size: 12px;
    color: #333;
}
</style>